<template>
  <div class="address" :class="theme_type">
    <div class="row">
      <div class="col-md-4 addressleft" :class="leftlayout">
        <h1 class="title_font2" :style="theme_type == 'showtime' ? '' : 'display:none'">{{$t('account.my_account')}}</h1>
        <div class="addnewbtn">
          <a href="#" @click="addresses=!addresses" class="main_button secondary_title">{{$t('account.add_new_address')}}</a>
          <!-- 切换显示隐藏 -->
        </div>
        <div v-if="theme_type==='default'" class="returnaccountbtn">
          <a href="/account" class="minor_button_color secondary_title">← {{$t('account.return_to_account')}}</a>
        </div>
      </div>
      <hr :style="theme_type == 'showtime' ? '' : 'display:none'" class="hr-small col-12 col-md-12"/>
      <div :style="theme_type == 'showtime' ? '' : 'display:none'" class="col-md-4 returnaccountbtn">
        <p>
            <a href="/account" class="minor_button_color secondary_title">
                {{$t('account.return_to_account')}}
            </a>
        </p>
      </div>
      <div class="col-md-8 addressright" :class="rightlayout">
        <v-addressfrom
          :theme_type="theme_type"
          v-show="addresses"
          @hiddenform="addresses=!addresses"
          :service="service"
          :address_list="address_list"
        ></v-addressfrom>
        <h4 class="secondary_title" v-if="theme_type=='default' || theme_type=='showtime'">{{$t('account.your_addresses')}}</h4>
        <ul>
          <li
            v-for="(item,index) in address_list"
            :class="{'addressitme_venue':theme_type=='venue'}"
            :key="item.id"
          >
            <p
              v-if="item.default && theme_type=='default'"
              class="default1 secondary_title"
            >{{$t('account.default')}}</p>
            <h4 class="secondary_title" v-if=" item.default &&theme_type=='venue'">{{$t('account.default')}}</h4>
            <v-addressitem :theme_type="theme_type" :service="service" :addressitem="item"></v-addressitem>
            <p class="secondary_title" v-if="theme_type=='default'">
              <span @click="item.show=!item.show" class="minor_button_color ">{{$t('account.edit')}}</span>
              <span @click="open(item.id,index)" class="minor_button_color ">{{$t('account.delete')}}</span>
            </p>
            <p  v-if="theme_type=='venue'" class="editbtn secondary_title">
              <a @click="item.show=!item.show" class="minor_button_color ">{{$t('account.edit')}}</a>
              <a @click="open(item.id,index)" class="minor_button_color ">{{$t('account.delete')}}</a>
            </p>
            <p class="secondary_title" v-if="theme_type=='showtime'">
              <span @click="item.show=!item.show" class="minor_button_color ">{{$t('account.edit')}}</span>
              <span style="cursor:text">|</span>
              <span @click="open(item.id,index)" class="minor_button_color">{{$t('account.delete')}}</span>
            </p>
            <v-addressfrom
              :theme_type="theme_type"
              :update="item"
              v-show="item.show"
              @hiddenform="item.show = !item.show"
              :service="service"
              :address_list="address_list"
            ></v-addressfrom>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog :title="$t('account.warning')" :visible.sync="dialogVisible">
      <span class="secondary_title">
        <i class="iconfont icon-cm-2" style="color:red;"></i>
        {{$t('account.sure_delete_address')}}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button class="secondary_title" @click="dialogVisible = false" style="background-color:white !important;color:#606266 !important; border-color:#DCDFE6 !important;">{{$t('account.cancel')}}</el-button>
        <el-button
         class="main_button secondary_title"
          type="primary"
          @click="deleteaddress"
          :loading="loading"
        >{{$t('account.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import vAddressfrom from "./addressfrom";
import vAddressitem from "./addressitem";
// import API from "../../../API.js";
export default {
  props: ["address_book", "service", "theme_type"],
  data() {
    return {
      addresses: false,
      address_list: [],
      dialogVisible: false,
      id: "",
      index: "",
      loading: false,
      leftlayout: "",
      rightlayout: ""
    };
  },
  methods: {
    async deleteaddress(id, index) {
      try {
        this.loading = true;
        let res = await this.$axios.delete(API.deleteaddress + this.id);
        this.address_book.splice(this.index, 1);
        this.dialogVisible = false;
        this.loading = false;
        const tip = this.$t("account.deleted_successfully");
        this.$message.success(tip);
      } catch (error) {
        this.dialogVisible = false;
        if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    },
    open(id, index) {
      this.dialogVisible = true;
      this.id = id;
      this.index = index;
      // const h = this.$createElement;
      // this.$MessageBox({
      //   title: "warning",
      //   type: "warning",
      //   message: h("p", null, "Are you sure you wish to delete this address?"),
      //   showCancelButton: true,
      //   confirmButtonText: "confirm",
      //   cancelButtonText: "cancel",
      //   beforeClose: (action, instance, done) => {
      //     if (action === "confirm") {
      //       instance.confirmButtonLoading = true;
      //       instance.confirmButtonText = "wait...";
      //       this.deleteaddress(id, index, done, instance);
      //     } else {
      //       done();
      //     }
      //   }
      // }).catch(() => {
      //   return;
      // });
    }
  },
  mounted() {
    this.address_list = this.address_book;
    this.address_list?.forEach(item => {
      this.$set(item, "show", false); //起作用
    });
  },
  beforeMount() {
    if (this.theme_type == "venue") {
      this.leftlayout = "col-12 col-md-12";
      this.rightlayout = "col-12 col-md-12";
    }
    if (this.theme_type == "showtime") {
      this.leftlayout = "col-12 col-md-12";
      this.rightlayout = "col-md-8";
    }
  },
  components: {
    vAddressfrom,
    vAddressitem
  }
};
</script>
<style  lang='scss'>
.addressitme_venue {
  margin-bottom: 24px !important;
  padding-bottom: 24px;
  border-bottom: 1px solid #e4e4e4;
  &:last-child {
    border: none;
  }
  .editbtn {
    font-family: "Oswald", sans-serif;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 13px;
    color: #111;
    margin: 0 12px;
    position: relative;
  }
}
.address {
  text-align: left;
  .addressleft {
    .addnewbtn {
      margin-bottom: 50px;

      a {
        display: inline-block;
        padding: 12px 20px;
        background-color: #c90d0d;
        text-decoration: none;
        color: white;
      }
    }

    .returnaccountbtn {
      margin-bottom: 50px;

      a {
        color: black;
        text-decoration: none;
        font-size: 14px;
      }
    }
  }

  .addressright {
    h4 {
      font-size: 20px;
      margin-bottom: 10px;
    }

    ul {
      padding: 0;
      li {
        list-style: none;
        margin-bottom: 15px;
        .default1 {
          margin: 0 0 15px;
          color: #222323;
          font-size: 14px;
          font-weight: bolder;
        }

        p {
          margin-top: 15px;

          span {
            cursor: pointer;
          }
        }
      }
    }
  }
  .el-dialog__wrapper {
    .el-dialog {
      width: 420px !important;
      max-width: 100% !important;
    }
  }
}

.venue {
  text-align: center;
  .addnewbtn {
    a {
      height: 48px;
      font-size: 13px;
      line-height: 28px;
    }
  }
  .editbtn {
    a {
      position: relative;
      margin: 0 12px;
      font-size: 13px;
      color: #111;
      cursor: pointer;
      &:first-child:after {
        content: "";
        width: 4px;
        height: 4px;
        background: #999;
        position: absolute;
        right: -16px;
        top: 8px;
        border-radius: 50%;
      }
    }
  }
  input {
    border-radius: 0;
    height: 48px;
    line-height: 22px;
    padding: 12px;
    color: #1e0909;
    vertical-align: middle;
    border: 1px solid #e4e4e4 !important;
    background: #fff !important;
    width: 100%;
    margin-bottom: 12px;
    cursor: pointer;
    margin-top: 8px;
  }
  select {
    height: 48px;
    padding: 12px;
    line-height: 22px;
    margin-bottom: 12px;
    cursor: pointer;
    margin-top: 8px;
    border: 1px solid #e4e4e4 !important;
    background: #fff !important;
    margin-top: 8px;
  }

  .addressform {
    text-align: left;
    font-size: 15px;
    font-weight: bold;
    .setdefault {
      width: auto;
      height: auto;
    }
  }
}

.showtime {
  .row {
    .col-md-4 {
      flex: 0 0 33.3333333333%;
      max-width: 33.3333333333%;
      position: relative;
      width: 100%;
      padding-right: 0;
      padding-left: 0;
    }

    .col-md-8 {
      flex: 0 0 66.6666666667%;
      max-width: 66.6666666667%;
      position: relative;
      width: 100%;
      padding-right: 0;
      padding-left: 0;
    }

    .col-12 {
      flex: 0 0 100%;
      max-width: 100%;
      position: relative;
      width: 100%;
      padding-right: 0;
      padding-left: 0;
    }

    .col-md-12 {
      flex: 0 0 100%;
      max-width: 100%;
      position: relative;
      width: 100%;
      padding-right: 0;
      padding-left: 0;
    }

    .addressleft {
      display: flex;
      margin-bottom: 20px;
      flex-wrap: wrap;
      justify-content: space-between;

      h1 {
        color: #2f2f2f;
        font-size: 1.733em;
        margin: 0;
      }

      .addnewbtn {
        margin: 0;

        a {
          padding: 8px 12px 7px;
          font-size: 12px;
          transition: background-color 0.2s ease-out;
          background-color: #898e88;
          color: #f3f3f3;
          border-radius: 2px;
          font-family: "Lato", sans-serif;
          text-transform: uppercase;
          border: 1px solid transparent;
          font-weight: 400;
          line-height: 1.42857143;
        }

        a:hover,
        a:focus {
          background-color: #7c827b;
          color: #f3f3f3;
          transition: background-color 0.05s ease-in;
        }
      }
    }

    hr {
      clear: both;
      border-top: solid #dedede;
      border-width: 1px 0 0;
      height: 0;
    }

    .returnaccountbtn {
      p {
        a:hover,
        a:focus {
          color: #b0b3af;
        }
      }
    }

    .addressright {
      h4 {
        font-size: 1.333em;
        color: #2f2f2f;
        margin-top: 30px;
      }

      ul {
        li {
          &:first-child {
            .last_name:after {
              content: attr(data-default);
              font-style: italic;
            }
          }

          p {
            span:first-child:hover,
            span:first-child:focus {
              color: #b0b3af;
            }

            span:last-child:hover,
            span:last-child:focus {
              color: #b0b3af;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .addressleft {
    text-align: center;
  }

  .showtime {
    .row {
      .addressleft {
        justify-content: flex-start;
        margin-bottom: 0;

        h1 {
          width: 100%;
          text-align: left;
          margin-bottom: 30px;
        }
      }

      .returnaccountbtn {
        max-width: 100% !important;
        flex: 0 0 100%;
      }

      .addressright {
        max-width: 100% !important;
        flex: 0 0 100%;
      }
    }
  }
}
</style>
